import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'
import { isProductionEnv, isSandboxEnv } from 'lib/environment/environment'
import { useCookieConsent } from '@sequencehq/core-components'

const isSandboxOrProduction = isSandboxEnv() || isProductionEnv()

const applyReplayConsent = (granted: boolean): void => {
  // Replay only ever runs on customer-facing deployments.
  if (!isSandboxOrProduction) {
    return
  }

  const replay = Sentry.getReplay()

  if (granted && !replay) {
    Sentry.addIntegration(Sentry.replayIntegration({ maskAllText: false }))
  } else if (!granted && replay) {
    void replay.stop()
  }
}

// Syncs PostHog capture and Sentry session replay with the consent choice.
export const useConsentSync = (): void => {
  const { status } = useCookieConsent()

  useEffect(() => {
    if (status === 'accepted') {
      if (posthog.__loaded) {
        posthog.opt_in_capturing()
      }
      applyReplayConsent(true)
    } else if (status === 'rejected') {
      if (posthog.__loaded) {
        posthog.opt_out_capturing()
      }
      applyReplayConsent(false)
    }
    // status === null → leave opted-out-by-default; no replay.
  }, [status])
}
